import { useCallback } from 'react'
import { GridColumn as Column, Grid } from '@progress/kendo-react-grid'
import { Spinner } from 'components/Spinner'
import { initialState } from 'store/grid'
import { useApiClient } from 'utils/api/ApiClient'
import { useFetchOne } from 'utils/api/useFetch'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { buildQuery, FilterLogic } from 'utils/QueryHelpers'

import bonusTransactionsColumn from '../../bonusTransactionsColumns'

interface StateProps {
  client: {
    id: string
    name: string
  }
}

export const TransactionClientBonuses: React.FC<StateProps> = ({ client }) => {
  const walletsApiClient = useApiClient(WalletsApiClient)

  const callback = useCallback(async () => {
    const query = buildQuery(createBonusTransactionsQuery(client.id).search)
    return walletsApiClient.getBonusTransactions({ search: query, pageSize: 100, pageIndex: 1 })
  }, [client.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const { data, isLoading } = useFetchOne(callback)

  if (isLoading) {
    return <Spinner />
  }

  return (
    <Grid
      filterable={false}
      resizable
      data={data?.items}
      total={data?.totalResults}
      style={{ margin: '0.75rem' }}
    >
      {bonusTransactionsColumn
        .filter((c) => c.show !== false)
        .map((column, idx) => (
          <Column key={idx + 2} {...column} />
        ))}
    </Grid>
  )
}

const createBonusTransactionsQuery = (clientId: string) => {
  const initialGridState = initialState()

  return {
    search: {
      ...initialGridState.filter,
      logic: initialGridState.filter.logic,
      defaultFilters: {
        logic: FilterLogic.AND,
        filters: [
          {
            field: 'Client',
            operator: '==',
            value: clientId,
          },
        ],
      },
    },
  }
}
